/*
 * @Author: Tahiti
 * @Date: 2025-01-27 12:00:00
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-01-27 12:00:00
 * @Description: My Creations 页面多语言配置
 * @FilePath: /weryai-web/locales/modules/myCreations.ts
 */
export default {
    zh: {
        // 页面标题
        pageTitle: '我的创作',
        filterTitle: '筛选作品',

        // 筛选器
        all: '全部',
        videos: '视频',
        images: '图片',
        filterByTime: '按时间筛选',
        filterByType: '按类型筛选',

        // 状态提示
        loading: '加载中...',

        // 内容相关
        changeBackgroundToYellow: '把背景改为黄色',

        // 预览模态框
        download: '下载',
        downloading: '下载中...',

        // 空状态
        noContentTitle: '还没有创作任何内容',
        noContentDescription: '开始您的创作之旅，制作第一个AI生成的内容',
        createVideoNow: '立即创建视频',
        emptyTitle: '哎呀！看起来您还没有创建任何内容。',
        createNow: '立即创建',
        emptyStateIcon: '空状态图标',

        // 操作按钮
        preview: '预览',
        expand: '展开',
        edit: '编辑',
        downloadContent: '下载内容',

        // 内容类型
        imageCreation: '图片创作',
        videoCreation: '视频创作',

        // 分页器
        pagination: {
            total: '共 {total} 条',
            items: '条/页',
        },
        start_vip: '开通会员',
        vip_benefits: '解锁无限创作，4K超清画质',
        right_now: '立即升级',
        next_billing_date: '到期时间：{time}',
        my_creations: '我的作品',
        total_creations: '共 {total_number} 个',
        credits: '积分余额',
        recharge: '充值',
        lock_tips: '解锁无限创作额度与专属特权',
    },
    en: {
        // Page title
        pageTitle: 'My Creations',
        filterTitle: 'Filter creations',

        // Filters
        all: 'All',
        videos: 'Videos',
        images: 'Images',
        filterByTime: 'Filter by time',
        filterByType: 'Filter by type',

        // Status messages
        loading: 'Loading...',

        // Content related
        changeBackgroundToYellow: 'Change background to yellow',

        // Preview modal
        download: 'Download',
        downloading: 'Downloading...',

        // Empty state
        noContentTitle: 'No content created yet',
        noContentDescription:
            'Start your creative journey by making your first AI-generated content',
        createVideoNow: 'Create Video Now',
        emptyTitle: "Oops! It looks like you haven't created anything yet.",
        createNow: 'Create Now',
        emptyStateIcon: 'Empty state icon',

        // Action buttons
        preview: 'Preview',
        expand: 'Expand',
        edit: 'Edit',
        downloadContent: 'Download Content',

        // Content types
        imageCreation: 'Image creation',
        videoCreation: 'Video creation',

        // Pagination
        pagination: {
            total: 'Total {total} items',
            items: 'items/page',
        },
        start_vip: 'Get VIP',
        vip_benefits: 'Unlock unlimited creations, 4K Ultra HD quality',
        right_now: 'Upgrade now',
        next_billing_date: 'Expiry date: {time}',
        my_creations: 'My Creations',
        total_creations: 'Total {total_number}',
        credits: 'Credit balance',
        recharge: 'Top up',
        lock_tips: 'Unlock unlimited creation quota and exclusive perks',
    },
    ja: {
        filterTitle: '作品を絞り込む',
        // フィルター
        all: 'すべて',
        videos: '動画',
        images: '画像',

        // ステータスメッセージ
        loading: '読み込み中...',

        // コンテンツ関連
        changeBackgroundToYellow: '背景を黄色に変更',

        // プレビューモーダル
        download: 'ダウンロード',
        downloading: 'ダウンロード中...',

        // 空の状態
        noContentTitle: 'まだコンテンツを作成していません',
        noContentDescription:
            '最初のAI生成コンテンツを作成して、クリエイティブな旅を始めましょう',
        createVideoNow: '今すぐ動画を作成',
        emptyTitle: 'おっと！まだ何も作成していないようです。',
        createNow: '今すぐ作成',

        // アクションボタン
        expand: '展開',
        edit: '編集',
        downloadContent: 'コンテンツをダウンロード',

        // ページネーション
        pageTitle: 'マイ創作',
        filterByTime: '時間でフィルタ',
        filterByType: 'タイプでフィルタ',
        emptyStateIcon: '空の状態アイコン',
        preview: 'プレビュー',
        imageCreation: '画像作成',
        videoCreation: '動画作成',
        pagination: {
            total: '合計 {total} 件',
            items: '件/ページ',
        },
        start_vip: 'VIPに登録',
        vip_benefits: '無制限の作成と4K超高画質を解放',
        right_now: '今すぐアップグレード',
        next_billing_date: '有効期限：{time}',
        my_creations: '私の作品',
        total_creations: '合計 {total_number} 件',
        credits: 'クレジット残高',
        recharge: 'チャージ',
        lock_tips: '無制限の創作枠と専用特典を解放',
    },
    ko: {
        filterTitle: '작품 필터',
        // 필터
        all: '전체',
        videos: '비디오',
        images: '이미지',

        // 상태 메시지
        loading: '로딩 중...',

        // 콘텐츠 관련
        changeBackgroundToYellow: '배경을 노란색으로 변경',

        // 미리보기 모달
        download: '다운로드',
        downloading: '다운로드 중...',

        // 빈 상태
        noContentTitle: '아직 콘텐츠를 생성하지 않았습니다',
        noContentDescription:
            '첫 번째 AI 생성 콘텐츠를 만들어 창작 여행을 시작하세요',
        createVideoNow: '지금 비디오 만들기',
        emptyTitle: '앗! 아직 아무것도 만들지 않았습니다.',
        createNow: '지금 만들기',

        // 액션 버튼
        expand: '확장',
        edit: '편집',
        downloadContent: '콘텐츠 다운로드',

        // 페이지네이션
        pageTitle: '나의 창작물',
        filterByTime: '시간별 필터',
        filterByType: '유형별 필터',
        emptyStateIcon: '빈 상태 아이콘',
        preview: '미리보기',
        imageCreation: '이미지 창작',
        videoCreation: '비디오 창작',
        pagination: {
            total: '총 {total} 개',
            items: '개/페이지',
        },
        start_vip: 'VIP 가입',
        vip_benefits: '무제한 생성, 4K 초고화질 잠금 해제',
        right_now: '지금 업그레이드',
        next_billing_date: '만료일: {time}',
        my_creations: '내 작품',
        total_creations: '총 {total_number}개',
        credits: '크레딧 잔액',
        recharge: '충전',
        lock_tips: '무제한 제작 한도와 전용 특전을 잠금 해제',
    },
    es: {
        filterTitle: 'Filtrar creaciones',
        // Filtros
        all: 'Todo',
        videos: 'Videos',
        images: 'Imágenes',

        // Mensajes de estado
        loading: 'Cargando...',

        // Contenido relacionado
        changeBackgroundToYellow: 'Cambiar fondo a amarillo',

        // Modal de vista previa
        download: 'Descargar',
        downloading: 'Descargando...',

        // Estado vacío
        noContentTitle: 'Aún no has creado contenido',
        noContentDescription:
            'Comienza tu viaje creativo creando tu primer contenido generado por IA',
        createVideoNow: 'Crear Video Ahora',
        emptyTitle: '¡Ups! Parece que aún no has creado nada.',
        createNow: 'Crear Ahora',

        // Botones de acción
        expand: 'Expandir',
        edit: 'Editar',
        downloadContent: 'Descargar Contenido',

        // Paginación
        pageTitle: 'Mis Creaciones',
        filterByTime: 'Filtrar por tiempo',
        filterByType: 'Filtrar por tipo',
        emptyStateIcon: 'Icono de estado vacío',
        preview: 'Vista previa',
        imageCreation: 'Creación de imagen',
        videoCreation: 'Creación de video',
        pagination: {
            total: 'Total {total} elementos',
            items: 'elementos/página',
        },
        start_vip: 'Hazte VIP',
        vip_benefits: 'Desbloquea creaciones ilimitadas y calidad 4K Ultra HD',
        right_now: 'Mejorar ahora',
        next_billing_date: 'Fecha de vencimiento: {time}',
        my_creations: 'Mis creaciones',
        total_creations: 'Total {total_number}',
        credits: 'Saldo de créditos',
        recharge: 'Recargar',
        lock_tips:
            'Desbloquea un límite de creación ilimitado y beneficios exclusivos',
    },
    fr: {
        filterTitle: 'Filtrer les créations',
        // Filtres
        all: 'Tout',
        videos: 'Vidéos',
        images: 'Images',

        // Messages d'état
        loading: 'Chargement...',

        // Contenu lié
        changeBackgroundToYellow: 'Changer le fond en jaune',

        // Modal de prévisualisation
        download: 'Télécharger',
        downloading: 'Téléchargement...',

        // État vide
        noContentTitle: 'Aucun contenu créé pour le moment',
        noContentDescription:
            'Commencez votre voyage créatif en créant votre premier contenu généré par IA',
        createVideoNow: 'Créer une Vidéo Maintenant',
        emptyTitle: "Oups ! Il semble que vous n'ayez encore rien créé.",
        createNow: 'Créer Maintenant',

        // Boutons d'action
        expand: 'Développer',
        edit: 'Modifier',
        downloadContent: 'Télécharger le Contenu',

        // Pagination
        pageTitle: 'Mes Créations',
        filterByTime: 'Filtrar par temps',
        filterByType: 'Filtrar par type',
        emptyStateIcon: "Icône d'état vide",
        preview: 'Aperçu',
        imageCreation: "Création d'image",
        videoCreation: 'Création de vidéo',
        pagination: {
            total: 'Total {total} éléments',
            items: 'éléments/page',
        },
        start_vip: 'Devenir VIP',
        vip_benefits:
            'Débloquez des créations illimitées et la qualité 4K Ultra HD',
        right_now: 'Mettre à niveau maintenant',
        next_billing_date: "Date d'expiration : {time}",
        my_creations: 'Mes créations',
        total_creations: 'Total {total_number}',
        credits: 'Solde de crédits',
        recharge: 'Recharger',
        lock_tips:
            'Débloquez un quota de création illimité et des avantages exclusifs',
    },
    de: {
        filterTitle: 'Kreationen filtern',
        // Filter
        all: 'Alle',
        videos: 'Videos',
        images: 'Bilder',

        // Statusmeldungen
        loading: 'Wird geladen...',

        // Inhalt bezogen
        changeBackgroundToYellow: 'Hintergrund zu gelb ändern',

        // Vorschau-Modal
        download: 'Herunterladen',
        downloading: 'Herunterladen...',

        // Leerer Zustand
        noContentTitle: 'Noch kein Inhalt erstellt',
        noContentDescription:
            'Beginnen Sie Ihre kreative Reise, indem Sie Ihren ersten KI-generierten Inhalt erstellen',
        createVideoNow: 'Jetzt Video Erstellen',
        emptyTitle:
            'Hoppla! Es sieht so aus, als hätten Sie noch nichts erstellt.',
        createNow: 'Jetzt Erstellen',

        // Aktionsschaltflächen
        expand: 'Erweitern',
        edit: 'Bearbeiten',
        downloadContent: 'Inhalt Herunterladen',

        // Paginierung
        pageTitle: 'Meine Kreationen',
        filterByTime: 'Nach Zeit filtern',
        filterByType: 'Nach Typ filtern',
        emptyStateIcon: 'Leerer Status-Icon',
        preview: 'Vorschau',
        imageCreation: 'Bild-Erstellung',
        videoCreation: 'Video-Erstellung',
        pagination: {
            total: 'Gesamt {total} Elemente',
            items: 'Elemente/Seite',
        },
        start_vip: 'VIP freischalten',
        vip_benefits:
            'Unbegrenzte Kreationen & 4K-Ultra-HD-Qualität freischalten',
        right_now: 'Jetzt upgraden',
        next_billing_date: 'Ablaufdatum: {time}',
        my_creations: 'Meine Kreationen',
        total_creations: 'Insgesamt {total_number}',
        credits: 'Credit-Guthaben',
        recharge: 'Aufladen',
        lock_tips:
            'Unbegrenztes Erstellungskontingent und exklusive Vorteile freischalten',
    },
    ru: {
        filterTitle: 'Фильтр работ',
        // Фильтры
        all: 'Все',
        videos: 'Видео',
        images: 'Изображения',

        // Сообщения о состоянии
        loading: 'Загрузка...',

        // Связанный контент
        changeBackgroundToYellow: 'Изменить фон на желтый',

        // Модальное окно предварительного просмотра
        download: 'Скачать',
        downloading: 'Загрузка...',

        // Пустое состояние
        noContentTitle: 'Контент еще не создан',
        noContentDescription:
            'Начните свое творческое путешествие, создав первый контент, сгенерированный ИИ',
        createVideoNow: 'Создать Видео Сейчас',
        emptyTitle: 'Ой! Похоже, вы еще ничего не создали.',
        createNow: 'Создать Сейчас',

        // Кнопки действий
        expand: 'Развернуть',
        edit: 'Редактировать',
        downloadContent: 'Скачать Контент',

        // Пагинация
        pageTitle: 'Мои творения',
        filterByTime: 'Фильтр по времени',
        filterByType: 'Фильтр по типу',
        emptyStateIcon: 'Значок пустого состояния',
        preview: 'Предпросмотр',
        imageCreation: 'Создание изображений',
        videoCreation: 'Создание видео',
        pagination: {
            total: 'Всего {total} элементов',
            items: 'элементов/стр',
        },
        start_vip: 'Оформить VIP',
        vip_benefits:
            'Разблокируйте безлимитное создание и качество 4K Ultra HD',
        right_now: 'Обновить сейчас',
        next_billing_date: 'Дата окончания: {time}',
        my_creations: 'Мои работы',
        total_creations: 'Всего {total_number}',
        credits: 'Баланс кредитов',
        recharge: 'Пополнить',
        lock_tips:
            'Разблокируйте неограниченный лимит на создание и эксклюзивные привилегии',
    },
    pt: {
        filterTitle: 'Filtrar criações',
        // Filtros
        all: 'Tudo',
        videos: 'Vídeos',
        images: 'Imagens',

        // Mensagens de status
        loading: 'Carregando...',

        // Conteúdo relacionado
        changeBackgroundToYellow: 'Mudar fundo para amarelo',

        // Modal de visualização
        download: 'Baixar',
        downloading: 'Baixando...',

        // Estado vazio
        noContentTitle: 'Nenhum conteúdo criado ainda',
        noContentDescription:
            'Comece sua jornada criativa criando seu primeiro conteúdo gerado por IA',
        createVideoNow: 'Criar Vídeo Agora',
        emptyTitle: 'Ops! Parece que você ainda não criou nada.',
        createNow: 'Criar Agora',

        // Botões de ação
        expand: 'Expandir',
        edit: 'Editar',
        downloadContent: 'Baixar Conteúdo',

        // Paginação
        pageTitle: 'Minhas Criações',
        filterByTime: 'Filtrar por tempo',
        filterByType: 'Filtrar por tipo',
        emptyStateIcon: 'Ícone de estado vazio',
        preview: 'Visualizar',
        imageCreation: 'Criação de imagem',
        videoCreation: 'Criação de vídeo',
        pagination: {
            total: 'Total {total} itens',
            items: 'itens/página',
        },
        start_vip: 'Assinar VIP',
        vip_benefits: 'Desbloqueie criações ilimitadas e qualidade 4K Ultra HD',
        right_now: 'Atualizar agora',
        next_billing_date: 'Data de expiração: {time}',
        my_creations: 'Minhas criações',
        total_creations: 'Total {total_number}',
        credits: 'Saldo de créditos',
        recharge: 'Recarregar',
        lock_tips: 'Desbloqueie criação ilimitada e benefícios exclusivos',
    },
    it: {
        filterTitle: 'Filtra creazioni',
        // Filtri
        all: 'Tutto',
        videos: 'Video',
        images: 'Immagini',

        // Messaggi di stato
        loading: 'Caricamento...',

        // Contenuto correlato
        changeBackgroundToYellow: 'Cambia sfondo in giallo',

        // Modal di anteprima
        download: 'Scarica',
        downloading: 'Scaricamento...',

        // Stato vuoto
        noContentTitle: 'Nessun contenuto creato ancora',
        noContentDescription:
            'Inizia il tuo viaggio creativo creando il tuo primo contenuto generato da IA',
        createVideoNow: 'Crea Video Ora',
        emptyTitle: 'Ops! Sembra che tu non abbia ancora creato nulla.',
        createNow: 'Crea Ora',

        // Pulsanti di azione
        expand: 'Espandi',
        edit: 'Modifica',
        downloadContent: 'Scarica Contenuto',

        // Paginazione
        pageTitle: 'Le Mie Creazioni',
        filterByTime: 'Filtra per tempo',
        filterByType: 'Filtra per tipo',
        emptyStateIcon: 'Icona stato vuoto',
        preview: 'Anteprima',
        imageCreation: 'Creazione immagine',
        videoCreation: 'Creazione video',
        pagination: {
            total: 'Totale {total} elementi',
            items: 'elementi/pagina',
        },
        start_vip: 'Attiva VIP',
        vip_benefits: 'Sblocca creazioni illimitate e qualità 4K Ultra HD',
        right_now: 'Aggiorna ora',
        next_billing_date: 'Data di scadenza: {time}',
        my_creations: 'Le mie creazioni',
        total_creations: 'Totale {total_number}',
        credits: 'Saldo crediti',
        recharge: 'Ricarica',
        lock_tips: 'Sblocca creazioni illimitate e vantaggi esclusivi',
    },
    ar: {
        filterTitle: 'تصفية الأعمال',
        // المرشحات
        all: 'الكل',
        videos: 'فيديوهات',
        images: 'صور',

        // رسائل الحالة
        loading: 'جاري التحميل...',

        // المحتوى المرتبط
        changeBackgroundToYellow: 'تغيير الخلفية إلى الأصفر',

        // نافذة المعاينة
        download: 'تحميل',
        downloading: 'جاري التحميل...',

        // الحالة الفارغة
        noContentTitle: 'لم يتم إنشاء أي محتوى بعد',
        noContentDescription:
            'ابدأ رحلتك الإبداعية بإنشاء أول محتوى منشأ بالذكاء الاصطناعي',
        createVideoNow: 'إنشاء فيديو الآن',
        emptyTitle: 'عذراً! يبدو أنك لم تنشئ أي شيء بعد.',
        createNow: 'إنشاء الآن',

        // أزرار الإجراءات
        expand: 'توسيع',
        edit: 'تحرير',
        downloadContent: 'تحميل المحتوى',

        // الترقيم
        pageTitle: 'إبداعاتي',
        filterByTime: 'تصفية حسب الوقت',
        filterByType: 'تصفية حسب النوع',
        emptyStateIcon: 'أيقونة الحالة الفارغة',
        preview: 'معاينة',
        imageCreation: 'إنشاء صورة',
        videoCreation: 'إنشاء فيديو',
        pagination: {
            total: 'الإجمالي {total} عنصر',
            items: 'عناصر/صفحة',
        },
        start_vip: 'الترقية إلى VIP',
        vip_benefits: 'افتح إبداعات غير محدودة وجودة 4K فائقة الدقة',
        right_now: 'الترقية الآن',
        next_billing_date: 'تاريخ الانتهاء: {time}',
        my_creations: 'أعمالي',
        total_creations: 'الإجمالي {total_number}',
        credits: 'رصيد النقاط',
        recharge: 'إعادة الشحن',
        lock_tips: 'افتح إنشاءات غير محدودة وامتيازات حصرية',
    },
    tw: {
        // Page title
        pageTitle: '我的創作',
        filterTitle: '篩選作品',

        // Filters
        all: '全部',
        videos: '影片',
        images: '圖片',
        filterByTime: '依時間篩選',
        filterByType: '依類型篩選',

        // Status messages
        loading: '載入中...',

        // Content related
        changeBackgroundToYellow: '將背景改為黃色',

        // Preview modal
        download: '下載',
        downloading: '下載中...',

        // Empty state
        noContentTitle: '尚未建立任何內容',
        noContentDescription: '從建立第一個 AI 生成內容開始你的創作旅程',
        createVideoNow: '立即建立影片',
        emptyTitle: '哎呀！看起來你還沒有建立任何內容。',
        createNow: '立即建立',
        emptyStateIcon: '空狀態圖示',

        // Action buttons
        preview: '預覽',
        expand: '展開',
        edit: '編輯',
        downloadContent: '下載內容',

        // Content types
        imageCreation: '圖片創作',
        videoCreation: '影片創作',

        // Pagination
        pagination: {
            total: '共 {total} 項',
            items: '項/頁',
        },
        start_vip: '開通會員',
        vip_benefits: '解鎖無限創作，4K超清畫質',
        right_now: '立即升級',
        next_billing_date: '到期時間：{time}',
        my_creations: '我的作品',
        total_creations: '共 {total_number} 個',
        credits: '積分餘額',
        recharge: '充值',
        lock_tips: '解鎖無限創作額度與專屬特權',
    },
    pl: {
        // Page title
        pageTitle: 'Moje prace',
        filterTitle: 'Filtruj prace',

        // Filters
        all: 'Wszystko',
        videos: 'Wideo',
        images: 'Obrazy',
        filterByTime: 'Filtruj według czasu',
        filterByType: 'Filtruj według typu',

        // Status messages
        loading: 'Ładowanie...',

        // Content related
        changeBackgroundToYellow: 'Zmień tło na żółte',

        // Preview modal
        download: 'Pobierz',
        downloading: 'Pobieranie...',

        // Empty state
        noContentTitle: 'Brak utworzonych treści',
        noContentDescription:
            'Rozpocznij swoją kreatywną podróż, tworząc pierwszą treść wygenerowaną przez AI',
        createVideoNow: 'Utwórz wideo teraz',
        emptyTitle: 'Ups! Wygląda na to, że jeszcze nic nie utworzyłeś.',
        createNow: 'Utwórz teraz',
        emptyStateIcon: 'Ikona pustego stanu',

        // Action buttons
        preview: 'Podgląd',
        expand: 'Rozwiń',
        edit: 'Edytuj',
        downloadContent: 'Pobierz treść',

        // Content types
        imageCreation: 'Tworzenie obrazów',
        videoCreation: 'Tworzenie wideo',

        // Pagination
        pagination: {
            total: 'Łącznie {total} elementów',
            items: 'elementów/stronę',
        },
        start_vip: 'Zostań VIP',
        vip_benefits: 'Odblokuj nielimitowane tworzenie i jakość 4K Ultra HD',
        right_now: 'Ulepsz teraz',
        next_billing_date: 'Data wygaśnięcia: {time}',
        my_creations: 'Moje prace',
        total_creations: 'Łącznie {total_number}',
        credits: 'Saldo kredytów',
        recharge: 'Doładuj',
        lock_tips: 'Odblokuj nielimitowane tworzenie i ekskluzywne korzyści',
    },
    th: {
        // Page title
        pageTitle: 'ผลงานของฉัน',
        filterTitle: 'กรองผลงาน',

        // Filters
        all: 'ทั้งหมด',
        videos: 'วิดีโอ',
        images: 'รูปภาพ',
        filterByTime: 'กรองตามเวลา',
        filterByType: 'กรองตามประเภท',

        // Status messages
        loading: 'กำลังโหลด...',

        // Content related
        changeBackgroundToYellow: 'เปลี่ยนพื้นหลังเป็นสีเหลือง',

        // Preview modal
        download: 'ดาวน์โหลด',
        downloading: 'กำลังดาวน์โหลด...',

        // Empty state
        noContentTitle: 'ยังไม่มีเนื้อหาที่สร้าง',
        noContentDescription:
            'เริ่มต้นเส้นทางสร้างสรรค์ของคุณด้วยการสร้างคอนเทนต์ AI ชิ้นแรก',
        createVideoNow: 'สร้างวิดีโอเลย',
        emptyTitle: 'อุ๊ย! ดูเหมือนว่าคุณยังไม่ได้สร้างอะไรเลย',
        createNow: 'สร้างเลย',
        emptyStateIcon: 'ไอคอนสถานะว่าง',

        // Action buttons
        preview: 'ดูตัวอย่าง',
        expand: 'ขยาย',
        edit: 'แก้ไข',
        downloadContent: 'ดาวน์โหลดเนื้อหา',

        // Content types
        imageCreation: 'การสร้างภาพ',
        videoCreation: 'การสร้างวิดีโอ',

        // Pagination
        pagination: {
            total: 'ทั้งหมด {total} รายการ',
            items: 'รายการ/หน้า',
        },
        start_vip: 'สมัคร VIP',
        vip_benefits: 'ปลดล็อกการสร้างไม่จำกัดและคุณภาพ 4K Ultra HD',
        right_now: 'อัปเกรดตอนนี้',
        next_billing_date: 'วันหมดอายุ: {time}',
        my_creations: 'ผลงานของฉัน',
        total_creations: 'รวม {total_number} รายการ',
        credits: 'ยอดเครดิต',
        recharge: 'เติมเงิน',
        lock_tips: 'ปลดล็อกโควตาการสร้างไม่จำกัดและสิทธิพิเศษเฉพาะ',
    },
    da: {
        // Page title
        pageTitle: 'Mine kreationer',
        filterTitle: 'Filtrer kreationer',

        // Filters
        all: 'Alle',
        videos: 'Videoer',
        images: 'Billeder',
        filterByTime: 'Filtrer efter tid',
        filterByType: 'Filtrer efter type',

        // Status messages
        loading: 'Indlæser...',

        // Content related
        changeBackgroundToYellow: 'Skift baggrunden til gul',

        // Preview modal
        download: 'Download',
        downloading: 'Downloader...',

        // Empty state
        noContentTitle: 'Intet indhold oprettet endnu',
        noContentDescription:
            'Start din kreative rejse ved at lave dit første AI-genererede indhold',
        createVideoNow: 'Opret video nu',
        emptyTitle: 'Ups! Det ser ud til, at du ikke har oprettet noget endnu.',
        createNow: 'Opret nu',
        emptyStateIcon: 'Ikon for tom tilstand',

        // Action buttons
        preview: 'Forhåndsvisning',
        expand: 'Udvid',
        edit: 'Rediger',
        downloadContent: 'Download indhold',

        // Content types
        imageCreation: 'Billedoprettelse',
        videoCreation: 'Videooprettelse',

        // Pagination
        pagination: {
            total: 'I alt {total} elementer',
            items: 'elementer/side',
        },
        start_vip: 'Bliv VIP',
        vip_benefits: 'Lås op for ubegrænsede kreationer og 4K Ultra HD-kvalitet',
        right_now: 'Opgrader nu',
        next_billing_date: 'Udløbsdato: {time}',
        my_creations: 'Mine værker',
        total_creations: 'I alt {total_number}',
        credits: 'Kreditsaldo',
        recharge: 'Tank op',
        lock_tips: 'Lås op for ubegrænset oprettelse og eksklusive fordele',
    },
    no: {
        // Page title
        pageTitle: 'Mine kreasjoner',
        filterTitle: 'Filtrer kreasjoner',

        // Filters
        all: 'Alle',
        videos: 'Videoer',
        images: 'Bilder',
        filterByTime: 'Filtrer etter tid',
        filterByType: 'Filtrer etter type',

        // Status messages
        loading: 'Laster...',

        // Content related
        changeBackgroundToYellow: 'Endre bakgrunnen til gul',

        // Preview modal
        download: 'Last ned',
        downloading: 'Laster ned...',

        // Empty state
        noContentTitle: 'Ingen innhold opprettet ennå',
        noContentDescription:
            'Start den kreative reisen din ved å lage ditt første AI-genererte innhold',
        createVideoNow: 'Opprett video nå',
        emptyTitle: 'Oops! Det ser ut som du ikke har opprettet noe ennå.',
        createNow: 'Opprett nå',
        emptyStateIcon: 'Ikon for tom tilstand',

        // Action buttons
        preview: 'Forhåndsvisning',
        expand: 'Utvid',
        edit: 'Rediger',
        downloadContent: 'Last ned innhold',

        // Content types
        imageCreation: 'Bildeopprettelse',
        videoCreation: 'Videoopprettelse',

        // Pagination
        pagination: {
            total: 'Totalt {total} elementer',
            items: 'elementer/side',
        },
        start_vip: 'Bli VIP',
        vip_benefits: 'Lås opp ubegrenset skapelse og 4K Ultra HD-kvalitet',
        right_now: 'Oppgrader nå',
        next_billing_date: 'Utløpsdato: {time}',
        my_creations: 'Mine verk',
        total_creations: 'Totalt {total_number}',
        credits: 'Kredittsaldo',
        recharge: 'Fyll på',
        lock_tips: 'Lås opp ubegrenset skapingskvote og eksklusive fordeler',
    },
    nl: {
        // Page title
        pageTitle: 'Mijn creaties',
        filterTitle: 'Creations filteren',

        // Filters
        all: 'Alles',
        videos: "Video's",
        images: 'Afbeeldingen',
        filterByTime: 'Filter op tijd',
        filterByType: 'Filter op type',

        // Status messages
        loading: 'Bezig met laden...',

        // Content related
        changeBackgroundToYellow: 'Verander achtergrond naar geel',

        // Preview modal
        download: 'Download',
        downloading: 'Downloaden...',

        // Empty state
        noContentTitle: 'Nog geen content gemaakt',
        noContentDescription:
            'Start je creatieve reis door je eerste AI-gegenereerde content te maken',
        createVideoNow: 'Maak nu een video',
        emptyTitle: 'Oeps! Het lijkt erop dat je nog niets hebt gemaakt.',
        createNow: 'Maak nu',
        emptyStateIcon: 'Leegstatus-icoon',

        // Action buttons
        preview: 'Voorbeeld',
        expand: 'Uitvouwen',
        edit: 'Bewerken',
        downloadContent: 'Content downloaden',

        // Content types
        imageCreation: 'Afbeeldingscreatie',
        videoCreation: 'Videocreatie',

        // Pagination
        pagination: {
            total: 'Totaal {total} items',
            items: 'items/pagina',
        },
        start_vip: 'Word VIP',
        vip_benefits: 'Ontgrendel onbeperkte creaties en 4K Ultra HD-kwaliteit',
        right_now: 'Upgrade nu',
        next_billing_date: 'Vervaldatum: {time}',
        my_creations: 'Mijn creaties',
        total_creations: 'Totaal {total_number}',
        credits: 'Creditsaldo',
        recharge: 'Opwaarderen',
        lock_tips:
            'Ontgrendel onbeperkte creatielimiet en exclusieve voordelen',
    },
    id: {
        // Page title
        pageTitle: 'Kreasi Saya',
        filterTitle: 'Filter kreasi',

        // Filters
        all: 'Semua',
        videos: 'Video',
        images: 'Gambar',
        filterByTime: 'Filter berdasarkan waktu',
        filterByType: 'Filter berdasarkan jenis',

        // Status messages
        loading: 'Memuat...',

        // Content related
        changeBackgroundToYellow: 'Ubah latar belakang menjadi kuning',

        // Preview modal
        download: 'Unduh',
        downloading: 'Mengunduh...',

        // Empty state
        noContentTitle: 'Belum ada konten yang dibuat',
        noContentDescription:
            'Mulai perjalanan kreatifmu dengan membuat konten AI pertamamu',
        createVideoNow: 'Buat Video Sekarang',
        emptyTitle: 'Ups! Sepertinya kamu belum membuat apa pun.',
        createNow: 'Buat Sekarang',
        emptyStateIcon: 'Ikon status kosong',

        // Action buttons
        preview: 'Pratinjau',
        expand: 'Perluas',
        edit: 'Edit',
        downloadContent: 'Unduh Konten',

        // Content types
        imageCreation: 'Pembuatan gambar',
        videoCreation: 'Pembuatan video',

        // Pagination
        pagination: {
            total: 'Total {total} item',
            items: 'item/halaman',
        },
        start_vip: 'Jadi VIP',
        vip_benefits: 'Buka kreasi tanpa batas dan kualitas 4K Ultra HD',
        right_now: 'Tingkatkan sekarang',
        next_billing_date: 'Tanggal kedaluwarsa: {time}',
        my_creations: 'Karya saya',
        total_creations: 'Total {total_number}',
        credits: 'Saldo kredit',
        recharge: 'Isi ulang',
        lock_tips: 'Buka kuota kreasi tanpa batas dan manfaat eksklusif',
    },
    tr: {
        // Page title
        pageTitle: 'Eserlerim',
        filterTitle: 'Oluşturulanları filtrele',

        // Filters
        all: 'Tümü',
        videos: 'Videolar',
        images: 'Görseller',
        filterByTime: 'Zamana göre filtrele',
        filterByType: 'Türe göre filtrele',

        // Status messages
        loading: 'Yükleniyor...',

        // Content related
        changeBackgroundToYellow: 'Arka planı sarıya değiştir',

        // Preview modal
        download: 'İndir',
        downloading: 'İndiriliyor...',

        // Empty state
        noContentTitle: 'Henüz içerik oluşturulmadı',
        noContentDescription:
            'İlk yapay zeka içeriğini oluşturarak yaratıcı yolculuğuna başla',
        createVideoNow: 'Şimdi Video Oluştur',
        emptyTitle: 'Hoppala! Görünüşe göre henüz hiçbir şey oluşturmadın.',
        createNow: 'Şimdi Oluştur',
        emptyStateIcon: 'Boş durum simgesi',

        // Action buttons
        preview: 'Önizleme',
        expand: 'Genişlet',
        edit: 'Düzenle',
        downloadContent: 'İçeriği indir',

        // Content types
        imageCreation: 'Görsel oluşturma',
        videoCreation: 'Video oluşturma',

        // Pagination
        pagination: {
            total: 'Toplam {total} öğe',
            items: 'öğe/sayfa',
        },
        start_vip: 'VIP ol',
        vip_benefits: 'Sınırsız oluşturma ve 4K Ultra HD kaliteyi aç',
        right_now: 'Şimdi yükselt',
        next_billing_date: 'Bitiş tarihi: {time}',
        my_creations: 'Eserlerim',
        total_creations: 'Toplam {total_number}',
        credits: 'Kredi bakiyesi',
        recharge: 'Yükle',
        lock_tips: 'Sınırsız oluşturma kotası ve özel ayrıcalıkları aç',
    },
}
